import React, { useRef } from "react";
import { Polyline, Popup, FeatureGroup } from "react-leaflet";
import Box from "@mui/material/Box";
import PopupBox from "../map/PopupBox";

const RenderMaxTerrainProfile = ({ data }) => {
  const shapeRef = useRef(null);

  return (
    <FeatureGroup ref={shapeRef}>
      {data.map((geometry, i) => {
        const coordinates = geometry.geometry_json.coordinates;

        return (
          <Polyline
            key={`${geometry.id}_${i}`}
            positions={coordinates}
            pathOptions={{
              color: "red",
              weight: 3,
              opacity: 1,
            }}
          >
            <Popup>
              <PopupBox>
                <Box>Terrain Profile</Box>
                <Box></Box>
                <Box>Rwy Direction:</Box>
                <Box>{geometry.rwy_direction}</Box>
              </PopupBox>
            </Popup>
          </Polyline>
        );
      })}
    </FeatureGroup>
  );
};

export default RenderMaxTerrainProfile;
